export default __webpack_public_path__ + "static/media/west-dir-btn.8dec5620.png";